import { useMemo } from 'react';

import { TITLES } from './constants';

import { AddressFieldType } from '.';

export interface AddressFieldsWrapperHook {
  title: string;
}

export default function useAddressFieldsWrapper(
  addressType: AddressFieldType,
): AddressFieldsWrapperHook {
  const title = useMemo(() => TITLES[addressType], [addressType]);

  return {
    title,
  };
}
